import React from "react";
import { NextPage } from "next";
import useIsMobile from "@src/hooks/useIsMobile";
import Template from "@app/Template/Template";
import ContactsPage from "@features/contacts-page/contacts-page";
import { CustomHead, DEFAULT_OG_IMAGE } from "@shared/ui/CustomHead";

const Contacts: NextPage = () => {
    const isMobile = useIsMobile();
    return (
        <Template bgColor={isMobile ? "white" : "blue"}>
            <CustomHead
                title={"Контакты | Связаться с нами"}
                description={
                    "Контактная информация компании. Свяжитесь с нами по телефону, email или через форму обратной связи."
                }
                robots={"index,follow"}
                openGraph={{
                    title: "Контакты | Связаться с нами",
                    description:
                        "Контактная информация компании. Свяжитесь с нами по телефону, email или через форму обратной связи.",
                    type: "website",
                    image: {
                        url: DEFAULT_OG_IMAGE,
                        width: 1200,
                        height: 630,
                        alt: "Контактная информация"
                    }
                }}
            />
            <ContactsPage showCompanyCard />
        </Template>
    );
};

export default Contacts;